"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TASKTYPE;
(function (TASKTYPE) {
    TASKTYPE["manualLogin"] = "manualLogin";
    TASKTYPE["idCard"] = "idcard";
    TASKTYPE["register"] = "register";
    TASKTYPE["doubleConfirm"] = "doubleConfirm";
    TASKTYPE["gpy"] = "gpy";
    TASKTYPE["qrCodeLogin"] = "qrCodeLogin";
    TASKTYPE["faceScanAuth"] = "faceScanAuth";
    TASKTYPE["signature"] = "signature";
    TASKTYPE["esign"] = "esign";
    TASKTYPE["commentAndRate"] = "commentAndRate";
    TASKTYPE["selectUserType"] = "selectUserType";
})(TASKTYPE = exports.TASKTYPE || (exports.TASKTYPE = {}));
